module.exports = __webpack_public_path__ + "img/giving2.0972ecd6.png";